import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero bg-base-200" }
const _hoisted_2 = { class: "hero-content text-center" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "items-center grid md:grid-cols-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "\n                mb-5\n                font-bold\n                text-5xl\n                md:text-6xl\n                lg:text-7xl\n                md:text-left\n                text-indigo-300\n              " }, " STEAMplug "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-xl lg:text-2xl md:text-left" }, " Our innovative educational technology makes teaching easier, learning more effective, and mastering STEAM natural. ")
], -1)

import CodingIllustration from "@/components/AboutUsHero/CodingIllustration.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CodingIllustration, { class: "w-full" }),
          _hoisted_5
        ])
      ])
    ])
  ]))
}
}

})